<template>
  <v-app id="app">
    <div id="nav">
      <Header :clientLogo="registrationConfig.clientLogo"/>
    </div>
    <router-view :productLogo="registrationConfig.product"></router-view>
    <Footer class="footer"></Footer>
  </v-app>
  <!--<v-app v-else-if="error && loaded">
    <Error/>
  </v-app>-->
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
import { userService } from '../_services'

export default {
  components: {
    Header,
    Footer
  },
  data () {
    return {
      loaded: false,
      error: false,
      registrationConfig: {}
    }
  },
  mounted () {
    let host = window.location.host
    userService.init(host).then(r => {
      this.loaded = true
      this.registrationConfig = r.data
      console.log(this.registrationConfig)
      if (r.data.primary !== null) {
        this.$vuetify.theme.themes.light.primary = this.registrationConfig.primary
      }
    }).catch(() => {
      this.loaded = true
      this.error = true
    })
  }
}
</script>

<style>
  #app {
    font-family: 'Ubuntu', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000;
    font-size: 16px;
  }

  #nav {
    padding: 0px;
  }

  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  #nav a.router-link-exact-active {
    color: #42b983;
  }

  .margin-top {
    margin-top: 100px;
  }

  .footer {
    bottom: 0;
    position: fixed;
    width: 100%;

  }

  #id {
    height: 100%;
  }
</style>
